export const ATTRIBUTION_UPLOAD_INPUT_TYPE = {
    Attributions: 'attributions',
    Schedule: 'schedule',
    Jpm: 'jpm',
};
export const ATTRIBUTION_UPLOAD_INPUT_TYPES = [
    ATTRIBUTION_UPLOAD_INPUT_TYPE.Attributions,
    ATTRIBUTION_UPLOAD_INPUT_TYPE.Schedule,
    ATTRIBUTION_UPLOAD_INPUT_TYPE.Jpm,
];
